import Vue from 'vue';
import axios from 'axios';
import store from '../store';
import Cookies from 'js-cookie';


// 适配vue-resource

const instance = axios.create();
instance.interceptors.request.use(config=> {
  //Serialize.decode(config);
  return config;
});
instance.interceptors.response.use(response=> {
  return response.data;
}, err=> {
  if (err.response) {
    axios.post('/client/error', err.response);
    const error = err.response.data
    // 响应拦截器里统一弹出接口报错
    if(error.code != 0 && error.message){
      Vue.prototype.$message.error(error.message);
      if(error.code === 500 && error.message === '请登录'){
        store.commit('clearInfo');
      }
    }
    return Promise.reject(err.response.data);
  }
  return Promise.reject({ code: 1024, message: err.message });
});

function plugin(Vue) {
  if (plugin.installed) {
    return;
  }
  Vue.http = instance;
}

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(plugin);
}

export default plugin;



// WEBPACK FOOTER //
// ./src/plugin/axios.js